export default __webpack_public_path__ + "static/media/market-gif3.baa0dfff.gif";